<mce-page-with-navigation>
    <h1>Manage shared billing users</h1>
    @if (verified()) {
        <p>Invite people to use myCableEngineering with their usage billed to your account.</p>
        <mat-toolbar class="mb-4">
            <mat-toolbar-row class="mce-datatable-toolbar-row">
                <button matButton="elevated" type="button" class="mr-auto"
                        (click)="membersResource.reload()" [disabled]="processing() || membersResource.isLoading()">
                    <mat-icon>refresh</mat-icon>Refresh
                </button>
                <button matButton="elevated" type="button" (click)="addUser()" [disabled]="processing()">
                    <mat-icon>add</mat-icon>Add User
                </button>
            </mat-toolbar-row>
        </mat-toolbar>

        @if (operationError()) {
            <p role="alert">{{ operationError() }}</p>
        }
        @if (processing() || membersResource.isLoading()) {
            <mat-progress-bar mode="indeterminate" aria-label="Updating shared billing users" />
        }
        @if (loadError()) {
            <p role="alert">Could not load shared billing users. {{ loadError() }}</p>
            <button matButton type="button" (click)="membersResource.reload()" [disabled]="processing()">Retry</button>
        } @else if (members().length) {
            <div class="overflow-x-auto">
                <mce-data-table [displayedColumns]="columns"
                                [data]="members()"
                                [headers]="headers"
                                [cellTemplates]="{ actions: rowActions, joined: joinedTime }" />
            </div>
        } @else if (!membersResource.isLoading()) {
            <p>No shared billing users yet. Use Add User to invite someone.</p>
        }

        <ng-template #joinedTime let-row="row">
            {{ row.joined ? (row.joined | date:'medium') : '—' }}
        </ng-template>
        <ng-template #rowActions let-row="row">
            <button mat-icon-button type="button" [matMenuTriggerFor]="moreActions"
                    [disabled]="processing() || !row.uid"
                    [attr.aria-label]="'More actions for ' + row.email">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #moreActions>
                @if (row.status === 'pending') {
                    <button mat-menu-item (click)="resendInvitation(row)" [disabled]="processing()">
                        <mat-icon>forward_to_inbox</mat-icon>Resend invitation
                    </button>
                }
                <button mat-menu-item (click)="removeUser(row)" [disabled]="processing()">
                    <mat-icon>person_remove</mat-icon>{{ row.status === 'pending' ? 'Cancel invitation' : 'Remove user' }}
                </button>
            </mat-menu>
        </ng-template>
        <a matButton routerLink="/settings" class="mt-4">Back to Settings</a>
    } @else {
        <p role="status">Verifying access…</p>
    }
</mce-page-with-navigation>
